module.exports = __webpack_public_path__ + "media/images/general/signature-8b8df256bf25aae636bed454b65bbd23.svg";